"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { isAuthenticated } from "@/utils/auth";

export default function AuthRedirectGuard({ children, redirectTo = "/" }) {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Check authentication immediately
    const checkAuth = () => {
      if (typeof window !== "undefined") {
        const authenticated = isAuthenticated();
        
        if (authenticated) {
          // Redirect immediately if authenticated
          router.replace(redirectTo);
        } else {
          // Show auth page if not authenticated
          setShouldRender(true);
        }
        
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [router, redirectTo]);

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Only render children if not authenticated
  return shouldRender ? children : null;
} 